    // helper to format remaining time into "Xm YYs" or "X minutes"
    export const formatRemainingTimeForMeeting = (ms: number) => {
        if (ms <= 0) return "0s";
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        }
        return `${seconds}s`;
    };